<ion-buttons class="buttons">
    <ion-button class="ion-no-margin button-up" color="light" (click)="scrollToTop()">
        <span inlineSVG="assets/images/icon-arrow-down.svg"></span>
    </ion-button>
    <ion-button class="ion-no-margin button-down" color="light" (click)="scrollToBottom()">
        <span inlineSVG="assets/images/icon-arrow-down.svg"></span>
    </ion-button>
</ion-buttons>
